import script from "./SkewedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedTab.vue?vue&type=script&setup=true&lang=js"

import "./SkewedTab.vue?vue&type=style&index=0&id=ca51099c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca51099c"]])

export default __exports__